import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { map, Observable, of } from 'rxjs';
import { IEmployeeRole } from 'src/app/employee/employee-roles';
import { EmployeeRoleService } from 'src/app/employee/services/employee-role.service';

@Injectable({
  providedIn: 'root'
})
export class EmployeeRoleResolver  {

  constructor(
    private employeeRoleService : EmployeeRoleService
  ){}

  resolve(
    route: ActivatedRouteSnapshot, 
    state: RouterStateSnapshot
    ): Observable<IEmployeeRole[]> {
      return this.employeeRoleService.listEmployeeRoleRoles({pageNumber: 0, pageSize: 999999})
      .pipe(
        map(response => response.data)
      )
  }
}
